// extracted by mini-css-extract-plugin
export var content = "styles-module--content--pk4Se";
export var highlight = "styles-module--highlight--EJG-J";